export enum OnlinePaymentAnnouncementAction {
  Close = 'close',
  LearnMore = 'learn-more',
}
